import { dateFormatOptions } from '@/config/constants';
import AppVersion from '@/features/profile/AppVersion';
import usePreferences from '@/features/profile/Preferences/usePreferences';
import Terms from '@/features/profile/Terms';
import TokenGenerationComponent from '@/features/profile/TokenGeneration';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';
import GroupedSelect from '@/shared/ui/primitives/GroupedSelect';

const Preferences = () => {
  const {
    timezone,
    changeUserSetting,
    dateFormat,
    timezoneOptions,
    marketsOptions,
    defaultMarket,
    homepage,
    homepageOptions,
    saving
  } = usePreferences();

  const isPersonalizationEnabled = useFlag(FeatureFlag.PersonalizationEnabled);

  return (
    <>
      <GroupedSelect
        disabled={saving}
        label='Timezone'
        options={timezoneOptions}
        value={timezone.value}
        onChange={userSetting => {
          changeUserSetting('timezone', userSetting);
        }}
      />
      <GroupedSelect
        disabled={saving}
        label='Date Format'
        options={dateFormatOptions}
        value={dateFormat.value}
        onChange={userSetting => {
          changeUserSetting('dateFormat', userSetting);
        }}
      />
      {isPersonalizationEnabled && (
        <GroupedSelect
          disabled={saving}
          label='Homepage'
          options={homepageOptions}
          value={homepage.value}
          onChange={userSetting => {
            changeUserSetting('homepage', userSetting);
          }}
        />
      )}
      {!isPersonalizationEnabled && (
        <GroupedSelect
          disabled={saving}
          label='Default Market'
          options={marketsOptions}
          value={defaultMarket.value}
          onChange={userSetting => {
            changeUserSetting('defaultMarket', userSetting);
          }}
        />
      )}

      <TokenGenerationComponent />
      <Terms />
      <AppVersion />
    </>
  );
};

export default Preferences;
